<template>
    <b-container>
      <b-row  v-if="$route.name !== 'company_list' && $route.name !== 'home' && !($store.state.company.block_address_navigation && $store.state.company.block_address_navigation === 'YES_LIST')" align-h="center" style="cursor:pointer;height:50px;line-height:50px;margin-top:20px;text-align:left;color:#ffffff;font-size:16px;font-weight: 300;">
        <b-col cols="11" class="rowlink">
          <a class="amenu" href="#/home"><font-awesome-icon style="font-size:20px;margin-right:15px;color:#525962;" :icon="['fal', 'home']"/>Home</a>
        </b-col>
      </b-row>

      <b-row
        v-if="$store.state.company.block_address_navigation && $store.state.company.block_address_navigation === 'YES_LIST' && $route.name !== 'company_list'"
        align-h="center" style="cursor:pointer;height:50px;line-height:50px;text-align:left;color:#ffffff;font-size:16px;font-weight: 300;">
        <b-col cols="11" class="rowlink">
          <a class="amenu" :href="'#/company_list/' + $store.state.lastLatLongUri"><font-awesome-icon style="font-size:20px;margin-right:15px;color:#525962;" :icon="['fal', 'store']"/>Home Lojas</a>
        </b-col>
      </b-row>

      <b-row v-if="$route.name !== 'ongoing'" align-h="center" style="cursor:pointer;height:50px;line-height:50px;text-align:left;color:#ffffff;font-size:16px;font-weight: 300;">
        <b-col cols="11" class="rowlink">
          <a class="amenu" href="#/ongoing"><font-awesome-icon style="font-size:20px;margin-right:15px;color:#525962;" :icon="['fal', 'shipping-timed']"/>Pedidos em Andamento</a>
        </b-col>
      </b-row>

      <b-row v-if="$route.name !== 'history'"  align-h="center" style="cursor:pointer;height:50px;line-height:50px;text-align:left;color:#ffffff;font-size:16px;font-weight: 300;">
        <b-col cols="11" class="rowlink">
          <a class="amenu" href="#/history"><font-awesome-icon style="font-size:20px;margin-right:15px;color:#525962;" :icon="['fal', 'shopping-basket']"/>Histórico de Compras</a>
        </b-col>
      </b-row>
      <b-row align-h="center" v-if="$store.state.activateOffers && $route.name !== 'offers'" style="cursor:pointer;height:50px;line-height:50px;text-align:left;color:#ffffff;font-size:16px;font-weight: 300;">
        <b-col cols="11" class="rowlink">
          <a class="amenu" href="#/offers"><font-awesome-icon style="font-size:20px;margin-right:15px;color:#525962;" :icon="['fal', 'badge-percent']"/>Ativar Ofertas - Lojas físicas</a>
        </b-col>
      </b-row>
      <b-row align-h="center" v-if="$store.state.company.hasMembership && $store.state.company.hasMembership === true && ($mq === 'mobile' || $mq === 'tablet') && $route.name !== 'membership_prizes'" style="cursor:pointer;height:50px;line-height:50px;text-align:left;color:#ffffff;font-size:16px;font-weight: 300;">
        <b-col cols="11" class="rowlink">
          <a class="amenu" href="#/membership_prizes"><font-awesome-icon style="font-size:20px;margin-right:15px;color:#525962;" :icon="['fal', 'gift']"/>Clube de Benefícios</a>
        </b-col>
      </b-row>
      <b-row v-if="!($store.state.company.block_address_navigation && $store.state.company.block_address_navigation === 'YES_LIST') && $route.name !== 'map'" align-h="center" style="cursor:pointer;height:50px;line-height:50px;text-align:left;color:#ffffff;font-size:16px;font-weight: 300;">
        <b-col cols="11" class="rowlink">
          <a class="amenu" href="#/map"><font-awesome-icon style="font-size:20px;margin-right:15px;color:#525962;" :icon="['fal', 'map-marked']"/>Informações de Entrega</a>
        </b-col>
      </b-row>
      <b-row  v-if="$store.getters.getChoicedCompany.whatsapp" align-h="center" style="cursor:pointer;height:50px;line-height:50px;text-align:left;color:#ffffff;font-size:16px;font-weight: 300;">
        <b-col cols="11" class="rowlink">
          <a class="amenu" :href="'https://api.whatsapp.com/send?phone=' + $store.getters.getChoicedCompany.whatsapp"  target="_blank"><font-awesome-icon style="font-size:20px;margin-right:15px;color:#525962;" :icon="['fab', 'whatsapp']"/>Whatsapp</a>
        </b-col>
      </b-row>
      <b-row v-if="$route.name !== 'contact'" align-h="center" style="cursor:pointer;height:50px;line-height:50px;text-align:left;color:#ffffff;font-size:16px;font-weight: 300;">
        <b-col cols="11" class="rowlink">
          <a class="amenu" href="#/contact"><font-awesome-icon style="font-size:20px;margin-right:15px;color:#525962;" :icon="['fal', 'headset']"/>Contato</a>
        </b-col>
      </b-row>
    </b-container>
</template>

<script>
export default {
  created () {
    console.log('Menu links', this.$route.name)
  }
}
</script>

<style>
.amenu {
  color: #171D33!important;
}

.rowlink {
  border-bottom: 1px solid #EAE7E7;
}
</style>
